import config from "../config";
import { isTeacherPreviewIdentityId } from "@/utils/toolSettingsUtils";
export interface ShippingDetail {
  status: string;
  shipDate: string | null;
  trackingNumber: string | null;
  carrier: string | null;
  itemTypeCode: string;
  itemDescription: string;
}
/**
 * Fetch shipping details API
*/
export const getShippingDetails = async (
  studentIdentityId: string,
  token: string
): Promise<ShippingDetail[] | null> => {
  if (isTeacherPreviewIdentityId(studentIdentityId)) {
    return [];
  }

  const SHIPPING_API_URL = config.api.endpoints.SHIPPING_DETAILS(studentIdentityId);
  try {
    const response = await fetch(SHIPPING_API_URL, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch shipping details: ${response.status} ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error while fetching shipping details:", error);
    return [];
  }
};
